export enum ECustomersQueryKey {
  CUSTOMERS = 'CUSTOMERS',
  CUSTOMER = 'CUSTOMER',
  CUSTOMER_DEALERSHIPS = 'CUSTOMER_DEALERSHIPS',
  CUSTOMER_APPLICATIONS = 'CUSTOMER_APPLICATIONS',
  CUSTOMER_DEALERSHIP_APPLICATION = 'CUSTOMER_DEALERSHIP_APPLICATION',
  SEARCH_CUSTOMER_DEALERSHIPS = 'SEARCH_CUSTOMER_DEALERSHIPS',
  SEARCH_CUSTOMER = 'SEARCH_CUSTOMER',
}
